import React from "react";
import { Server, Bot, BarChart2, ShieldCheck, ExternalLink } from "lucide-react";

const McpServerPage = () => {
  return (
    <div className="w-full max-w-4xl mx-auto p-6 md:p-8 space-y-6">
      {/* ── Page Header ── */}
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between pb-5 border-b border-gray-200 gap-3">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-xl bg-blue-600 text-white flex items-center justify-center shadow-xs">
            <Server size={20} />
          </div>
          <div>
            <h1 className="text-xl font-bold text-gray-900 leading-tight">MCP Server</h1>
            <p className="text-xs text-gray-500 mt-0.5">
              Model Context Protocol integration for Academic Online
            </p>
          </div>
        </div>

        <div className="flex items-center">
          <span className="inline-flex items-center gap-1.5 text-xs text-blue-700 bg-blue-50 px-2.5 py-1 rounded-full font-medium border border-blue-200">
            <span className="w-1.5 h-1.5 rounded-full bg-blue-600 animate-pulse" />
            Coming Soon • In Development
          </span>
        </div>
      </div>

      {/* ── Coming Soon Announcement Card ── */}
      <div className="bg-white rounded-xl border border-gray-200 p-8 sm:p-12 text-center shadow-xs">
        <div className="w-16 h-16 rounded-2xl bg-blue-50 text-blue-600 flex items-center justify-center mx-auto mb-4 border border-blue-100">
          <Server size={30} />
        </div>

        <h2 className="text-xl sm:text-2xl font-bold text-gray-900 tracking-tight mb-2">
          MCP Server is Coming Soon
        </h2>

        <p className="text-sm text-gray-600 max-w-xl mx-auto leading-relaxed mb-8">
          We are developing the official Model Context Protocol (MCP) server for Academic Online. Soon, you will be able to connect AI assistants such as Claude Desktop, Cursor, and custom research agents directly to our verified academic knowledge graph.
        </p>

        {/* 3 Core Highlights */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-3.5 max-w-3xl mx-auto mb-8 text-left">
          <div className="p-4 rounded-lg bg-gray-50 border border-gray-100">
            <div className="flex items-center gap-2 text-xs font-semibold text-gray-900 mb-1">
              <Bot size={15} className="text-blue-600" />
              <span>Direct AI Queries</span>
            </div>
            <p className="text-xs text-gray-500 leading-relaxed">
              Query scholars, citations, and publication metrics directly inside your prompt context.
            </p>
          </div>

          <div className="p-4 rounded-lg bg-gray-50 border border-gray-100">
            <div className="flex items-center gap-2 text-xs font-semibold text-gray-900 mb-1">
              <BarChart2 size={15} className="text-blue-600" />
              <span>Institutional Benchmarks</span>
            </div>
            <p className="text-xs text-gray-500 leading-relaxed">
              Supply AI agents with verified university KPIs, department statistics, and grant portfolios.
            </p>
          </div>

          <div className="p-4 rounded-lg bg-gray-50 border border-gray-100">
            <div className="flex items-center gap-2 text-xs font-semibold text-gray-900 mb-1">
              <ShieldCheck size={15} className="text-blue-600" />
              <span>Secure &amp; Standardized</span>
            </div>
            <p className="text-xs text-gray-500 leading-relaxed">
              Open JSON-RPC protocol standard with fine-grained personal access tokens.
            </p>
          </div>
        </div>

        {/* Footer Meta */}
        <div className="pt-6 border-t border-gray-100 flex flex-wrap items-center justify-center gap-4 text-xs text-gray-500">
          <div className="flex items-center gap-1.5">
            <span className="text-gray-400">Target Release:</span>
            <span className="font-medium text-gray-700">Q2 2027</span>
          </div>

          <span className="text-gray-300">•</span>

          <div className="flex items-center gap-1.5">
            <span className="text-gray-400">Standard:</span>
            <span className="font-medium text-gray-700">Anthropic Model Context Protocol</span>
          </div>

          <span className="text-gray-300">•</span>

          <a
            href="https://modelcontextprotocol.io"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-1 text-blue-600 hover:text-blue-700 font-medium transition-colors"
          >
            <span>Documentation</span>
            <ExternalLink size={12} />
          </a>
        </div>
      </div>
    </div>
  );
};

export default McpServerPage;
